module.exports = __webpack_public_path__ + "img/icon_send_inactive.b0eab5eb.svg";